// extracted by mini-css-extract-plugin
export var growableInput = "_a9-0";
export var tagContainer = "_a9-2";
export var textInput = "_a9-1";